export default __webpack_public_path__ + "static/media/26.f8be62f1.jpg";